<template>
  <div v-if="incomes.length" class="income-group">
    <div class="income-group__title">
      {{ role === "applicant" ? "Žiadateľ" : "Spolužiadateľ" }}
    </div>
    <article
      v-for="income in incomes"
      :key="income.id"
      class="income-card"
      :class="{'income-card--rejected': !income.success}"
    >
      <div class="income-card__header">
        <div>
          <span>{{ income.type }}</span>
          <strong>{{ income.employer || income.type }}</strong>
        </div>
        <div class="income-card__accepted">
          <span>{{ income.success ? "Akceptovaný príjem" : "Neakceptovaný príjem" }}</span>
          <strong>{{ income.success ? money(income.acceptedMonthly) : "0 EUR" }} / mes.</strong>
        </div>
      </div>

      <ul v-if="income.facts.length" class="income-card__facts">
        <li v-for="(fact, index) in income.facts" :key="index">{{ fact }}</li>
      </ul>

      <div v-if="income.annualDebtCapacity !== null" class="income-card__capacity">
        Doplnková kontrola DTI: z tohto príjmu vzniká limit celkového zadlženia
        <strong>{{ money(income.annualDebtCapacity) }}</strong>.
      </div>

      <div v-if="income.details.length" class="income-card__details">
        {{ income.details.join(" ") }}
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: "ClientDtiInfoCard",
  props: {
    incomes: {
      type: Array,
      default: () => [],
    },
    role: {
      type: String,
      required: true,
      validator: (value) => ["applicant", "coapplicant"].includes(value),
    },
  },
  methods: {
    money(value) {
      const parsed = Number(value);
      if (!Number.isFinite(parsed)) return "—";
      return `${new Intl.NumberFormat("sk-SK", {
        maximumFractionDigits: 2,
      }).format(parsed)} EUR`;
    },
  },
};
</script>

<style scoped>
.income-group {
  display: flex;
  flex-direction: column;
  gap: 9px;
  margin-top: 12px;
}

.income-group + .income-group {
  margin-top: 18px;
}

.income-group__title {
  color: var(--app-text-muted);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.income-card {
  padding: 15px;
  border: 1px solid var(--app-border);
  border-radius: 14px;
  background: var(--app-surface-muted);
}

.income-card--rejected {
  border-color: rgba(223, 102, 115, 0.5);
}

.income-card__header {
  display: flex;
  gap: 16px;
  justify-content: space-between;
}

.income-card__header > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.income-card__header span,
.income-card__capacity,
.income-card__details {
  color: var(--app-text-muted);
  font-size: 11px;
  line-height: 1.45;
}

.income-card__header strong {
  color: var(--app-text);
  font-size: 14px;
}

.income-card__accepted {
  align-items: flex-end;
  text-align: right;
}

.income-card__accepted strong {
  color: var(--app-primary);
  white-space: nowrap;
}

.income-card__facts {
  display: grid;
  gap: 5px;
  margin: 12px 0 0;
  padding: 10px 0 0 18px;
  border-top: 1px solid var(--app-border);
  color: var(--app-text-muted);
  font-size: 11px;
  line-height: 1.45;
}

.income-card__capacity,
.income-card__details {
  margin-top: 9px;
}

.income-card__capacity strong {
  color: var(--app-text);
}

.income-card__details {
  color: #df6673;
}

@media (max-width: 480px) {
  .income-card__header {
    flex-direction: column;
  }

  .income-card__accepted {
    align-items: flex-start;
    text-align: left;
  }
}
</style>
